import { defineStore } from 'pinia'

export const useTeamStore = defineStore('team', {
  state: () => {
    return {
      team: [
        {
            id: 1,
            firstname: 'Bram',
            lastname: 'Vanhees',
            function: 'Kinesitherapie',
            description: 'Description - Team member 1',
            email: 'bram@impulskinesitherapie.be',
            image: require('../assets/images/team/bram.jpg'),
            birthday: '1990-09-09',
            city: 'Diepenbeek',
            phone: '0499/99.99.99',
            quote: "Hard work pays off !",
            specs: ["Sportkinesitherapeut", "Specialist onderste lidmaat", "Post operatieve revalidatie", "Loopscreening", "Blessurepreventie coach"]
        },
        {
            id: 2,
            firstname: 'Bart',
            lastname: 'Vanhees',
            function: 'Rugschool & hartcoherentie',
            description: 'Description - Team member 3',
            email: 'bart@impulskinesitherapie.be',
            image: require('../assets/images/team/bart.jpg'),
            birthday: '1990-09-09',
            city: 'Diepenbeek',
            phone: '0499/99.99.99',
            quote: "Mind your body!",
            specs: ["Rugscholing", "Chronische rug- en nekklachten", "Post operatieve revalidatie", "Hartcoherentie", "Craniale therapie", "Stress gerelateerde klachten"]
        },
        {
            id: 3,
            firstname: 'Michiel',
            lastname: 'Froyen',
            function: 'Training & coaching',
            description: 'Description - Team member 4',
            email: 'michiel@impulskinesitherapie.be',
            image: require('../assets/images/team/michiel.jpg'),
            birthday: '1990-09-09',
            city: 'Diepenbeek',
            phone: '0499/99.99.99',
            quote: "Greatest wealth is health!",
            specs: ["Sportkinesitherapeut", "Specialist bovenste lidmaat", "Post operatieve revalidatie", "Bike fitting"]
        },
        {
            id: 4,
            firstname: 'Robbe',
            lastname: 'Jonckers',
            function: 'Training & coaching',
            description: 'Description - Team member 5',
            email: 'robbe@impulskinesitherapie.be',
            image: require('../assets/images/team/robbe.jpg'),
            birthday: '1990-09-09',
            city: 'Diepenbeek',
            phone: '0499/99.99.99',
            quote: "Mens sana in corpore sano!",
            specs: ["Sportkinesitherapeut", "Specialist wervelkolom", "Osteopaat I.O."]
        },
        {
            id: 5,
            firstname: 'Gillès',
            lastname: 'Gérimont',
            function: 'Training & coaching',
            description: 'Description - Team member 2',
            email: 'gilles@impulskinesitherapie.be',
            image: require('../assets/images/team/gilles.jpg'),
            birthday: '1990-09-09',
            city: 'Diepenbeek',
            phone: '0499/99.99.99',
            quote: "Get a little better every single day!",
            specs: ["Personal training", "Groepslessen", "Sportspecifieke begeleiding"]
        },
      ]
    }
  },
  actions: {
    getTeam() {
        return this.team;
    },

    getTeamMember(id) {
        return this.team.find(teamMember => teamMember.id+"" === id+"");
    },

    getFourRandom(excludeId) {
        let team = this.team.filter(teamMember => teamMember.id+"" !== excludeId+"");
        return team.sort(() => Math.random() - Math.random()).slice(0, 4);
    }
  }
});
